import { Routes } from '@angular/router';
import { languageRedirectGuard } from './core/guards/language-redirect.guard';
import { acquisitionTypesResolver } from './core/resolvers/acquisition-types.resolver';
import { languageResolver } from './core/resolvers/language.resolver';
import { partnerResolver } from './core/resolvers/partner.resolver';
import { policiesResolver } from './core/resolvers/policies.resolver';
import { SetInitialPasswordComponent } from './features/auth/set-initial-password/set-initial-password.component';
import { AdminShellComponent } from './shared/components/admin-shell/admin-shell.component';
import { AppShellComponent } from './shared/components/app-shell/app-shell.component';

export const APP_ROUTES: Routes = [
    // Admin Routes
    {
        path: 'conf',
        component: AdminShellComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                loadComponent: () => import('./features/admin/home/admin-home.component').then((m) => m.AdminHomeComponent),
            },
            {
                path: 'auth',
                loadComponent: () => import('./features/admin/auth/admin-auth.component').then((m) => m.AdminAuthComponent),
            },
            {
                path: 'system-notifications',
                loadComponent: () => import('./features/admin/system-notifications/admin-system-notification.component').then((m) => m.AdminSystemNotificationComponent),
            },
            {
                path: 'cronjobs',
                loadComponent: () => import('./features/admin/cron-jobs/admin-cron-jobs.component').then((m) => m.AdminCronJobsComponent),
            },
            {
                path: 'feedback',
                loadComponent: () => import('./features/admin/feedback/admin-feedback.component').then((m) => m.AdminFeedbackComponent),
            },
            {
                path: 'messenger',
                loadComponent: () => import('./features/admin/messenger/admin-messenger.component').then((m) => m.AdminMessengerComponent),
            },
            {
                path: 'reset-registration',
                loadComponent: () => import('./features/admin/reset-registration/admin-reset-registration.component').then((m) => m.AdminResetRegistrationComponent),
            },
        ],
    },
    // set-initial-password, no ui just redirect
    {
        path: 'set-initial-password',
        component: SetInitialPasswordComponent,
    },
    // Partner Routes
    {
        path: ':lang',
        canActivate: [languageRedirectGuard],
        component: AppShellComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'examples',
                loadComponent: () => import('./features/_examples/examples.component').then((m) => m.ExamplesComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                },
            },
            {
                path: 'home',
                loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                    policies: policiesResolver,
                },
            },
            {
                path: 'policies',
                loadChildren: () => import('./features/policies/policies.routes').then((m) => m.POLICIES_ROUTES),
                resolve: {
                    lang: languageResolver,
                    policies: policiesResolver,
                },
            },
            {
                path: 'profile',
                loadComponent: () => import('./features/profile/profile.component').then((m) => m.ProfileComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                    policies: policiesResolver,
                    acquisitionTypes: acquisitionTypesResolver,
                },
            },
            {
                path: 'contact',
                loadComponent: () => import('./features/contact/contact.component').then((m) => m.ContactComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                },
            },
            {
                path: 'messenger',
                loadComponent: () => import('./features/messenger/messenger.component').then((m) => m.MessengerComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                },
            },
            {
                path: 'callback-request',
                loadComponent: () => import('./features/callback-request/callback-request.component').then((m) => m.CallbackRequestComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                },
            },
            {
                path: 'inbox',
                loadComponent: () => import('./features/inbox/inbox.component').then((m) => m.InboxComponent),
                resolve: {
                    lang: languageResolver,
                    partner: partnerResolver,
                },
            },
            {
                path: 'form-downloads',
                loadComponent: () => import('./features/form-download/form-download.component').then((m) => m.FormDownloadComponent),
                resolve: {
                    lang: languageResolver,
                },
            },
            {
                path: 'terms',
                loadComponent: () => import('./features/terms/terms.component').then((m) => m.TermsComponent),
                resolve: {
                    lang: languageResolver,
                },
            },
            {
                path: 'auth',
                loadComponent: () => import('./features/auth/auth.component').then((m) => m.AuthComponent),
                resolve: {
                    lang: languageResolver,
                },
            },
            {
                path: 'identificationcode',
                loadComponent: () => import('./features/auth/identification-code/identification-code.component').then((m) => m.IdentificationCodeComponent),
                resolve: {
                    lang: languageResolver,
                },
            },
            {
                path: 'identificationcode/:code',
                loadComponent: () => import('./features/auth/identification-code/identification-code.component').then((m) => m.IdentificationCodeComponent),
                resolve: {
                    lang: languageResolver,
                },
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'de/home',
    },
];
